module.exports = __webpack_public_path__ + "static/logo-nsd-68f7a032cf67a15ce529d77fb2e6b6cf.webp";